import { SVGProps } from "react";

const SIHouzz = (props: SVGProps<SVGSVGElement>) => <svg role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" {...props}><title>{"Houzz"}</title><path d="M1.27 0V24H9.32V16.44H14.68V24H22.73V10.37L6.61 5.75V0H1.27Z" /></svg>;

export { SIHouzz };